import React from "react";
import { Button } from "antd";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import icons from "Common/Icons";
import { CONSTANTS } from "utils/constant";
class PatientDetailAssessment extends React.Component {
  _baseClassName = "patient-detail-assessment-container";
  constructor(props) {
    super(props);

    this.state = {
      data: this.props?.data || [],
      baseUrl: this.props.baseUrl || [],
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.data !== prevState.data) {
      return {
        data: nextProps.data,
      };
    }
  }
  render() {
    return (
      <div className={this._baseClassName}>
        <div className="patient-detail-assessment-main">
          <div className="header-container">
            <img src={icons.assessment_score}></img>
            <div className="header-name">{CONSTANTS.ASSESSMENT_SCORE}</div>
          </div>
          {this.state.data ? (
            <div className="main-content">
              <div>{CONSTANTS.BASED_ON_RECENT_ASSESSMENT}</div>
              {(this.state.data.question_type == "emotion" || this.state.data.question_type == "senior_adult") ? (
                <>
                  <div className="test-content">
                    <div>{CONSTANTS.DEPRESSION}</div>
                    <div>{this.state.data.phq_score}</div>
                  </div>
                  <div className="test-content">
                    <div>{CONSTANTS.ANXIETY}</div>
                    <div>{this.state.data.gad_score}</div>
                  </div>
                </>
              ) : (
                <div className="test-content">
                  <div>{CONSTANTS.STRESS}</div>
                  <div>{this.state.data.stress_score}</div>
                </div>
              )}
              <div
                className="bottom-content"
                {...((this.state.data?.user_type == "adult" || this.state.data?.user_type ==  "senior_adult") && {
                  style: {
                    justifyContent: "space-between",
                    height: "45px",
                    alignItems: "center",
                  },
                })}
              >
                <div className="patient-settings">
                  {(this.state.data?.user_type == "adult" || this.state.data?.user_type == "senior_adult")   ? (
                    <Button
                      className="assesment-set-btn"
                      // style={{
                      //   backgroundColor: "#5A4C95",
                      //   color: "#FFFFFF",
                      //   marginLeft: 5,
                      // }}
                      onClick={this.props.handleSettingsEdit}
                    >
                      {CONSTANTS.ASSESSMENT_SETTINGS}
                    </Button>
                  ) : null}
                </div>

                <Link
                  to={{
                    pathname: "assessment-history",
                    state: { user_type: this.state.data?.user_type || "",
                             patientName : this.props?.patientName || "",
                             patientUID : this.props?.patientUID || "",
                             patient_last_name : this.props?.patient_last_name || ""
                   },
                  }}
                >
                  <Button icon={<img src={icons.arrow_icon} />}>
                    {CONSTANTS.VIEW_ALL}
                  </Button>
                </Link>
              </div>
            </div>
          ) : null}
          {(this.state.data?.anxiety_score < 0 &&
            this.state.data?.depression_score < 0) ||
          this.state.data == undefined ? (
            <div className="main-content error-message">
              <div>{CONSTANTS.NO_ASSESSMENT_TAKEN}</div>
              <div
                className="bottom-content"
                {...((this.props?.user_type == "adult" || this.props?.user_type == "senior_adult") && {
                  style: {
                    justifyContent: "space-between",
                    height: "45px",
                    alignItems: "center",
                  },
                })}
              >
                <div className="patient-settings">
                  {(this.props?.user_type == "adult" || this.props?.user_type == "senior_adult") ? (
                    <Button
                      className="assesment-set-btn"
                      // style={{
                      //   backgroundColor: "#5A4C95",
                      //   color: "#FFFFFF",
                      //   marginLeft: 5,
                      // }}
                      onClick={this.props.handleSettingsEdit}
                    >
                      {CONSTANTS.ASSESSMENT_SETTINGS}
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    baseUrl: state.loginReducer.user_details.baseUrl,
  };
};
export default connect(mapStateToProps)(PatientDetailAssessment);
